// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { setAuthToken } from './config/axiosConfig';

import Navbar from './components/Navbar';
import Home from './views/Home';
import Login from './views/Login';
import Form from './views/Form';
import FormIngreso from './views/forms/FormIngreso';
// import FormPrimerContacto from './views/forms/FormPacienteInicial';
import FormPacienteInicial from './views/forms/FormPacienteInicial';
import FormIngresoEnfermeria from './views/forms/FormIngresoEnfermeria';

import BusquedaAuxiliar from './views/BusquedaAuxiliar';
import AcuerdoMutuo from './views/AcuerdoMutuo';

import NuevoAcuerdoMutuo from './views/NuevoAcuerdoMutuo';
import NuevoAcuerdoMutuo2 from './views/NuevoAcuerdoMutuo2';

import IngresoCandidata from './views/IngresoCandidata';
import IngresoEvaluaciones from './views/IngresoEvaluaciones';

import SolicitudesReemplazo from './views/SolicitudesReemplazo';
import SolicitudeReemplazo from './views/SolicitudReemplazo';


import CalendarioTurnos from './views/CalendarioTurnos';
import CalendarioTurnosFinanciero from './views/CalendarioTurnosFinanciero';
import IngresoReemplazos from './views/IngresoReemplazos';
import IngresoReemplazos2 from './views/IngresoReemplazos2';
import SolicitudReemplazo2 from './views/SolicitudReemplazo2';
import IngresoAdicionales from './views/IngresoAdicionales';
import BitacoraCoordinacion from './views/BitacoraCoordinacion';
import ResumenPacientesCoordinacion from './views/ResumenPacientesCoordinacion';

import IngresoAuxiliar from './views/IngresoAuxiliar';
import RepositorioCv from './views/RepositorioCv';
import NominaAuxiliares from './views/NominaAuxiliares';
import NominaAuxiliaresFinanciero from './views/NominaAuxiliaresFinanciero';

import NominaPaciente from './views/NominaPaciente';
import DocumentosPacientes from './views/DocumentosPacientes';
import FormVisita from './views/FormVisita';
import BitacoraPaciente from './views/BitacoraPaciente';

import Cobranza from './views/Cobranza';
import CompararPeriodo from './views/CompararPeriodo';
import CompararPeriodoHonorario from './views/CompararPeriodoHonorarios';
import SeguimientoPagos from './views/SeguimientoPagos';
import ConciliacionPagos from './views/ConciliacionPagos';

import Egresos from './views/components/Egresos';
import Ingresos from './views/components/Ingresos';
import Cartola from './views/components/Cartola';
import EstadoResultados from './views/components/EstadoResultados';
import GraficosReportes from './views/components/GraficosReportes';
import CartolaPacientes from './views/CartolaPacientes';
import CobranzaFacturas from './views/CobranzaFacturas';

import "./App.css";
import Remuneraciones from './views/Remuneraciones';
import Reajuste from './views/Reajuste';
import ReajusteAuxiliar from './views/ReajusteAuxiliar';
import ReajusteValoresFamilia from './views/ReajusteValoresFamilia';
import RegistroEventos from './views/RegistroEventos';
import BoletasHonorarios from './views/components/BoletasHonorarios';

import Usuarios from './views/Usuarios';
import UsuariosForm from './views/UsuariosForm';
import Perfiles from './views/Perfiles';
import PerfilesForm from './views/PerfilesForm';
import PagosPaciente from './views/PagosPaciente';
import AcuerdosMutuos from './views/AcuerdosMutuos';
import Novedades from './views/Novedades';
import PlanificacionSector from './views/PlanificacionSector';
import RecuperarContrasena from './views/RecuperarContrasena';
import CambiarContrasena from './views/CambiarContrasena';
import EditarPaciente from './views/forms/EditarPaciente';
import SolicitudesAdicionales from './views/SolicitudesAdicionales';
import EditarAuxiliar from './views/forms/EditarAuxiliar';
import Honorarios from './views/Honorarios';
import HonorariosAdelanto from './views/HonorariosAdelanto';
import HistorialVersiones from './views/HistorialVersiones';
import Ayuda from './views/Ayuda';
import AuditoriaTurnos from './views/AuditoriaTurnos';
import UsoCalendario from './views/UsoCalendario';
import Liquidaciones from './views/Liquidaciones';
import LiquidacionDetalle from './views/LiquidacionDetalle';

//Parametros
import ConfigParametros from './views/ConfigParametros';
import ListaVisitas from './views/ListaVisitas';
import NominaPacienteFinanciero from './views/NominaPacienteFinanciero';

import ConfiguracionHonorarios from './views/honorarios/ConfiguracionHonorarios';
import PeriodoTurno from './views/PeriodoTurno';
import PeriodoTurnoRecalculoDia from './views/PeriodoTurnoRecalculoDia';
import PatronesRotacion from './views/PatronesRotacion';
import CorreoTemplates from './views/CorreoTemplates';
import packageJson from '../package.json';

function App() {
    // Verifica si el usuario está autenticado
    const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('isAuthenticated') === 'true');

    // Si la sesión cambia (por login/logout), actualiza el estado
    useEffect(() => {
        setIsAuthenticated(localStorage.getItem('isAuthenticated') === 'true');
    }, [isAuthenticated]);

    // Si el usuario no está autenticado, solo renderizamos el login
    if (!isAuthenticated) {
        return (<Router>
            <Routes>
                <Route path="/" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
                <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
            </Routes>
        </Router>);
    }

    const token = localStorage.getItem('authToken');
    if (token) {
        setAuthToken(token);
    }

    // Si el usuario está autenticado, renderizamos la aplicación completa
    return (
        <Router>
            <div>
                {/* Navbar siempre visible */}
                <Navbar />

                {/* Rutas para las vistas */}
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/form" element={<Form />} />
                    {/* Inicio */}
                    <Route path="/form-paciente-inicial/:id?" element={<FormPacienteInicial />} />
                    <Route path="/editar-paciente/:pacienteID" element={<EditarPaciente />} />
                    <Route path="/form-ingreso-enfermeria/:id?" element={<FormIngresoEnfermeria />} />
                    <Route path="/form-ingreso" element={<FormIngreso />} />
                    {/* <Route path="/form-primer-contacto" element={<FormPrimerContacto />} /> */}

                    <Route path="/busqueda-auxiliar" element={<BusquedaAuxiliar />} />
                    <Route path="/acuerdo-mutuo" element={<NuevoAcuerdoMutuo2 />} />
                    <Route path="/anterior-acuerdo-mutuo" element={<AcuerdoMutuo />} />
                    <Route path="/acuerdos-mutuos" element={<AcuerdosMutuos />} />
                    <Route path="/nuevo-acuerdo-mutuo-2" element={<NuevoAcuerdoMutuo2 />} />
                    <Route path="/novedades" element={<Novedades />} />
                    <Route path="/planificacion-sector" element={<PlanificacionSector />} />

                    <Route path="/ingreso-candidata" element={<IngresoCandidata />} />
                    <Route path="/ingreso-evaluaciones" element={<IngresoEvaluaciones />} />

                    <Route path="/calendario-turnos" element={<CalendarioTurnos />} />
                    <Route path="/calendario-turnos-financiero" element={<CalendarioTurnosFinanciero />} />

                    <Route path="/solicitudes-reemplazos" element={<SolicitudesReemplazo />} />
                    <Route path="/solicitud-reemplazo/:id_solicitud?" element={<SolicitudeReemplazo />} />
                    <Route path="/new-solicitud-reemplazo" element={<SolicitudReemplazo2 />} />
                    <Route path="/ingreso-reemplazos/:id_solicitud?" element={<IngresoReemplazos />} />
                    <Route path="/new-ingreso-reemplazos/:id_solicitud?" element={<IngresoReemplazos2 />} />
                    <Route path="/ingreso-adicionales" element={<IngresoAdicionales />} />
                    <Route path="/lista-adicionales" element={<SolicitudesAdicionales />} />
                    <Route path="/bitacora-coordinacion" element={<BitacoraCoordinacion />} />
                    <Route path="/resumen-coordinacion" element={<ResumenPacientesCoordinacion />} />
                    <Route path="/lista-visitas" element={<ListaVisitas />} />

                    <Route path="/ingreso-auxiliar/:id?" element={<IngresoAuxiliar />} />
                    <Route path="/repositorio-cvs" element={<RepositorioCv />} />
                    <Route path="/nomina-auxiliares" element={<NominaAuxiliares />} />
                    <Route path="/nomina-auxiliares-financiero" element={<NominaAuxiliaresFinanciero />} />
                    <Route path="/editar-auxiliar/:id" element={<EditarAuxiliar />} />

                    <Route path="/nomina-paciente" element={<NominaPaciente />} />
                    <Route path="/nomina-paciente-financiero" element={<NominaPacienteFinanciero />} />
                    <Route path="/documentos-paciente" element={<DocumentosPacientes />} />
                    <Route path="/form-visita/:id?" element={<FormVisita />} />
                    <Route path="/bitacora-paciente" element={<BitacoraPaciente />} />

                    <Route path="/cobranza" element={<Cobranza />} />
                    <Route path="/comparar-periodo" element={<CompararPeriodo />} />
                    <Route path="/seguimiento-pagos" element={<SeguimientoPagos />} />
                    <Route path="/conciliacion-pagos" element={<ConciliacionPagos />} />
                    <Route path="/boletas-honorarios" element={<BoletasHonorarios />} />
                    <Route path="/pagos-pacientes" element={<PagosPaciente />} />


                    <Route path="/estado-resultados" element={<EstadoResultados />} />
                    <Route path="/comparativo" element={<CompararPeriodoHonorario />} />
                    <Route path="/egresos" element={<Egresos />} />
                    <Route path="/ingresos" element={<Ingresos />} />
                    <Route path="/cartola" element={<Cartola />} />
                    <Route path="/cartola-pacientes" element={<CartolaPacientes />} />
                    <Route path="/facturas-cobranza" element={<CobranzaFacturas isPage={true} />} />
                    <Route path="/graficos-reportes" element={<GraficosReportes />} />

                    <Route path="/reajuste" element={<Reajuste />} />
                    <Route path="/reajuste-auxiliar" element={<ReajusteAuxiliar />} />
                    <Route path="/reajuste-valores-familia" element={<ReajusteValoresFamilia />} />

                    <Route path="/registro-eventos" element={<RegistroEventos />} />
                    <Route path="/usuarios" element={<Usuarios />} />
                    <Route path="/usuarios/:id" element={<UsuariosForm />} />
                    <Route path="/perfiles" element={<Perfiles />} />
                    <Route path="/perfiles/:id" element={<PerfilesForm />} />
                    <Route path="/cambiar-contrasena" element={<CambiarContrasena />} />

                    <Route path="/parametros" element={<ConfigParametros />} />
                    <Route path="/templates-correo" element={<CorreoTemplates />} />
                    <Route path="/historial-versiones" element={<HistorialVersiones />} />
                    <Route path="/ayuda" element={<Ayuda />} />


                    <Route path="/honorarios" element={<Honorarios />} />
                    <Route path="/honorarios-adelanto" element={<HonorariosAdelanto />} />
                    <Route path="/honorarios-dev" element={<Remuneraciones />} />

                    <Route path="/periodo-turno" element={<PeriodoTurno />} />
                    <Route path="/periodo-turno-recalculo-dia" element={<PeriodoTurnoRecalculoDia />} />
                    <Route path="/patrones-rotacion" element={<PatronesRotacion />} />

                    {/* Administración */}
                    <Route path="/auditoria-turnos" element={<AuditoriaTurnos />} />
                    <Route path="/uso-calendario" element={<UsoCalendario />} />

                    {/* Liquidaciones */}
                    <Route path="/liquidaciones" element={<Liquidaciones />} />
                    <Route path="/liquidacion/:periodo" element={<LiquidacionDetalle />} />

                    <Route path="/configuracion-honorarios" element={<ConfiguracionHonorarios />} />
                </Routes>
            </div>
            <div className="app-version">v{packageJson.version}</div>
        </Router>
    );
}

export default App;
